export enum MapPopupPositionEnum {
  left = 'left',
  right = 'right',
  top = 'top',
  bottom = 'bottom'
}
